import axios from 'axios';

export default class BannerService {
    doGetOnBoarding(perPage = 1) {
        return axios.get(`/api/banner/8?language=${language}&perPage=${perPage}`);
    }

    doGetFeatured(perPage = 1) {
        return axios.get(`/api/banner/9?language=${language}&perPage=${perPage}`);
    }

    doGetGrids(perPage = 1) {
        return axios.get(`/api/banner/10?language=${language}&perPage=${perPage}`);
    }

    doGetSmall(perPage = 1) {
        return axios.get(`/api/banner/7?language=${language}&perPage=${perPage}`);
    }

    doGetOffline(perPage = 1) {
        return axios.get(`/api/banner/11?language=${language}&perPage=${perPage}`);
    }

    doGetByType(type, params) {
        if (!params.perPage) params.perPage = '';
        return axios.get(`/api/banner/${type}?language=${language}&perPage=${params.perPage}`);
    }
}



// WEBPACK FOOTER //
// ./resources/site/js/providers/api/banner-service.js